import PaymentImportMasterPage from './PaymentImportMasterPage';

export default PaymentImportMasterPage;
